<div id="menuList" class="ya-typography" [ngClass]="isEMenu? 'ya-is-emenu':''">
  <div class="menu-header-container">
    <div class="menu-header-container--content">
      <button a11y_Button id="scroll-left" (click)="scrollLeft()" [class.inactive]="atStart">
        <div class="inline-icon ya-tag-sort-icon-svg rotate" inlineSVG="shop-icons.svg#ya-chevron_right"></div>
      </button>
      <ng-container *ngIf="itemGroups && itemGroups.length > 0">
        <mat-tab-group id="headerTabs" mat-stretch-tabs [selectedIndex]="currentItemGroupIndex"
          (selectedIndexChange)="itemGroupChange($event)"
          animationDuration="20ms"
          class="ya-tab-group ya-tab-group--bodyless">
          <ng-container *ngFor="let itemGroup of itemGroups">
            <mat-tab>
              <ng-template mat-tab-label>
                <span>
                  {{ itemGroup.label }}
                </span>
              </ng-template>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </ng-container>
      <button a11y_Button id="scroll-right" (click)="scrollRight()" [class.inactive]="atEnd">
        <div class="inline-icon ya-tag-sort-icon-svg" inlineSVG="shop-icons.svg#ya-chevron_right"></div>
      </button>
    </div>
    <div class="ya-tag-sort-icon-container">
      <a a11y_Button class="ya-tag-sort-icon-button" matRipple matRippleCentered="true" (click)="openNavModal()">
        <div class="inline-icon ya-tag-sort-icon-svg modalmenu" inlineSVG="shop-icons.svg#ya-hypersoft-modalmenu"></div>
      </a>
    </div>
  </div>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset" id="menuComponent"
    [class.warenkorb-padding]="itemsInBasket > 0">
    <div class="scrollmenu">
      <ya-subheader [hasContent]="true"></ya-subheader>
      <ng-container *ngIf="useRedeemCoupon && allowReedemCoupon ">
        <div class="coupon_redeem">
          <div class="ya-button-container">
            <button a11y_Button class="coupon_btn--selection" (click)="navigateToCouponRedeem()">
              <span langkey="phCoupon_Redeem_Btn_Label"></span>
              <div class="inline-icon coupon-icon" inlineSVG="shop-icons.svg#ya-hypersoft-coupon"></div>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isItemTagEnabled && itemTags && itemTags.length > 0">
        <div class="ya-tag-sort-icon-container">
          <a a11y_Button class="ya-tag-sort-icon-button" matRipple matRippleCentered="true" (click)="openTagsModal()">
            <div class="inline-icon ya-tag-sort-icon-svg" inlineSVG="shop-icons.svg#ya-hypersoft-preferences-filter">
            </div>
            <ng-container *ngIf="hasTagSorting()">
              <div class="ya-checkmark-container">
                <div class="inline-icon ya-tag-checkmark-icon" inlineSVG="shop-icons.svg#ya-hypersoft-check-voll"></div>
              </div>
            </ng-container>
          </a>
        </div>
      </ng-container>
    </div>
    <!--Calendar for ticket mode-->
    <ng-container *ngIf=" is_calendar_filter_enabled && isOrderModeTicket">
      <ya-calendar [availableDates]="dates" mode="ticket" (dateSelected)="onDateSelected($event)"></ya-calendar>
    </ng-container>
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="location-map-tabs">
        <mat-tab-group mat-stretch-tabs [selectedIndex]="currentItemGroupIndex" animationDuration="20ms"
          class="ya-headerless-tab-group">
          <ng-container *ngFor="let itemGroup of itemGroups">
            <mat-tab [label]="itemGroup.label">
              <div class="ya-tab-content-wrapper">
                <ng-container *ngIf="itemGroup.productList">
                  <ng-container
                    *ngIf="(itemGroup.productList.length>0) || (itemGroup.dislikeProductList && itemGroup.dislikeProductList.length > 0); then tabContent else emptyTab">
                  </ng-container>
                  <ng-template #tabContent>
                    <div class="item-column-container">
                      <div class="item-column-container--grid"
                        [class.grid-customized]="itemGroup.productList.length<=2">
                        <ng-container *ngFor="let product of itemGroup.productList">
                          <div class="item-column-container__item">
                            <ya-articlecard [product]="product" [isItemTagEnabled]="isItemTagEnabled"
                              [itemTagType]="itemTagType" [options]="ArticleCardConfig"
                              [returnItemGroupId]="activeItemGroupId">
                            </ya-articlecard>
                          </div>
                        </ng-container>
                      </div>
                      <ng-container *ngIf="itemGroup.dislikeProductList && itemGroup.dislikeProductList.length > 0">
                        <div a11y_Button class="disliketag-container">
                          <div class="disliketag-content">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-thumb-down"></div>
                            <div class="disliketag-text" langkey="phMenu_DislikeSeperator_title"></div>
                          </div>
                          <mat-divider></mat-divider>
                        </div>
                        <div class="item-column-container--grid"
                          [class.grid-customized]="itemGroup.dislikeProductList.length<=2">
                          <ng-container *ngFor="let product of itemGroup.dislikeProductList">
                            <div class="item-column-container__item">
                              <ya-articlecard [product]="product" [isItemTagEnabled]="isItemTagEnabled"
                                [itemTagType]="itemTagType" [options]="ArticleCardConfig"
                                [returnItemGroupId]="activeItemGroupId">
                              </ya-articlecard>
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                  </ng-template>
                  <ng-template #emptyTab>
                    <ya-emptypage [emptyTitle]="emptyTabTitel()" [emptyContent]="emptyTabInfo()"></ya-emptypage>
                  </ng-template>
                </ng-container>
              </div>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>

  <ng-container *ngIf="!isRemoteGroupOrder&& itemsInBasket > 0">
    <a @plopInOut routerLink="/webshop" class="warenkorb-btn" [matBadge]="itemsInBasket">
      <div class="text" langkey="phWebshop_View_Cart">
      </div>
      <div class="icon">
        <div id="header-icon-basket" class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
      </div>
    </a>
  </ng-container>

</div>